import { render, staticRenderFns } from "./AuthLayout1.vue?vue&type=template&id=56fb2f70"
import script from "./AuthLayout1.vue?vue&type=script&lang=js"
export * from "./AuthLayout1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports